import React, { PureComponent, Fragment } from 'react';

// Components
import Header from 'components/header/header.component';
import Hero from 'components/hero/hero.component';
import About from 'components/about/about.component';
import Cost from 'components/cost/cost.component';
import {StyledTextWrapper, StyledUseWrapper} from '../programDetails/programDetails.style';
import renderHTML from 'react-render-html';
import text from 'i18l';
import {
  StyledElementWrapperCenter,
  StyledElementHeaderTitle,
  StyledElementHeaderDescription
} from 'styledElements';

class HomeComponent extends PureComponent {

  render() {
  const { location: {pathname} } = this.props;

    return (
      <Fragment>
        <Header/>
        <Hero  currentUrl={pathname}/>
        <About />
        <Cost />
        <StyledUseWrapper more>
          <StyledElementWrapperCenter>
            <header>
              <StyledElementHeaderTitle>
                Myjnia Koło
              </StyledElementHeaderTitle>
              <StyledElementHeaderDescription>
                POZNAJ NAS
              </StyledElementHeaderDescription>
            </header>
            <StyledTextWrapper>
              {renderHTML(text.HOME.TEXT)}
            </StyledTextWrapper>

          </StyledElementWrapperCenter>
        </StyledUseWrapper>
      </Fragment>
    );
  }
}

export default HomeComponent;



// WEBPACK FOOTER //
// ./src/routes/home/home.component.js